<mat-tab-group animationDuration="0ms" [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)">
  <mat-tab label="Basic Information">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="container">
        <div class="full-width-container">
          <section class="section-container nrg-border-radius">
            <div class="section-header">
              Basic Information
            </div>
            <div class="section-content">
              <div class="form-field-container">
                <mat-form-field appearance="fill" class="form-field">
                  <mat-label>Name</mat-label>
                  <input matInput formControlName="name" required appTextNormalize>
                </mat-form-field>
              </div>
              <div class="form-field-container form-field-container-with-columns">
                <div class="form-field-container-half">
                  <mat-form-field appearance="fill" class="form-field">
                    <mat-label>Category</mat-label>
                    <mat-select formControlName="category" [compareWith]="compareById">
                      <mat-option *ngFor="let category of categories" [value]="category">
                        {{ category.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="form-field-container-half">
                  <mat-form-field appearance="fill" class="form-field">
                    <mat-label>Subcategory</mat-label>
                    <mat-select formControlName="subcategory" [disabled]="!form.get('category')?.value" [compareWith]="compareById">
                      <mat-option *ngFor="let subcategory of subcategories" [value]="subcategory">
                        {{ subcategory.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="form-field-container">
                <mat-form-field appearance="fill" class="form-field">
                  <mat-label>Notes</mat-label>
                  <textarea matInput formControlName="notes" rows="4"></textarea>
                </mat-form-field>
              </div>
            </div>
          </section>
        </div>
      </div>

      <div class="form-actions">
        <button mat-flat-button color="primary" type="button" (click)="onSubmit()" [disabled]="!form.valid">
          <mat-icon>save</mat-icon>
          {{ submitButtonText }}
        </button>
        <button mat-flat-button type="button" class="nrg-error-flat-button" (click)="onCancel()">
          <mat-icon>clear</mat-icon>
          Cancel
        </button>
      </div>
    </form>
  </mat-tab>
  <mat-tab label="Pyramid" *ngIf="isEditMode">
    <app-pyramidal-shareholder-pyramid
      [pyramidsByYear]="pyramidsByYear"
      (editPyramidItem)="onEditPyramidItem($event)"
      (deletePyramidItem)="onDeletePyramidItem($event)">
    </app-pyramidal-shareholder-pyramid>
  </mat-tab>
</mat-tab-group>
